// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"History_wrapper__3Xi_m","year":"History_year__5rII0","title":"History_title__e3Kgm","description":"History_description__vD_9z","separator":"History_separator__ejoxA"};